import {TranslationObject} from '@colonist/i18n'
import {CostInformationPieceTypes, ModeSettingEnum} from '../../../../../../shared/GameEnums'
import {CardEnum, PlayerColor} from '@colonist/game-states'
import {getImagePath} from '../../../ui_utils/Utils.ts'

export interface CostInformation {
    piece: CostInformationPieceTypes
    cost: CardEnum[]
    title: TranslationObject
}

const baseGameCostsInformation: CostInformation[] = [
    {
        piece: CostInformationPieceTypes.Road,
        cost: [CardEnum.Lumber, CardEnum.Brick],
        title: {key: 'strings:game.PieceTypes.Road'},
    },
    {
        piece: CostInformationPieceTypes.Settlement,
        cost: [CardEnum.Lumber, CardEnum.Brick, CardEnum.Wool, CardEnum.Grain],
        title: {key: 'strings:game.PieceTypes.Settlement'},
    },
    {
        piece: CostInformationPieceTypes.City,
        cost: [CardEnum.Grain, CardEnum.Grain, CardEnum.Ore, CardEnum.Ore, CardEnum.Ore],
        title: {key: 'strings:game.PieceTypes.City'},
    },
]

const developmentCostInformation: CostInformation[] = [
    {
        piece: CostInformationPieceTypes.DevelopmentCard,
        cost: [CardEnum.Wool, CardEnum.Grain, CardEnum.Ore],
        title: {key: 'strings:game.PieceTypes.DevelopmentCard', options: {context: 'Abbreviated'}},
    },
]

const seafarersCosts: CostInformation[] = [
    {
        piece: CostInformationPieceTypes.Ship,
        cost: [CardEnum.Lumber, CardEnum.Wool],
        title: {key: 'strings:game.PieceTypes.Ship'},
    },
]

const citiesAndKnightsCosts: CostInformation[] = [
    {
        piece: CostInformationPieceTypes.CityWall,
        cost: [CardEnum.Brick, CardEnum.Brick],
        title: {key: 'strings:game.PieceTypes.CityWall'},
    },
    {
        piece: CostInformationPieceTypes.PurchaseKnight,
        cost: [CardEnum.Wool, CardEnum.Ore],
        title: {key: 'strings:game.tooltips.purchaseKnight'},
    },
    {
        piece: CostInformationPieceTypes.ActivateKnight,
        cost: [CardEnum.Grain],
        title: {key: 'strings:game.gameState.actions.activateKnightSelf'},
    },
    {
        piece: CostInformationPieceTypes.UpgradeKnight,
        cost: [CardEnum.Wool, CardEnum.Ore],
        title: {key: 'strings:game.gameState.actions.upgradeKnightSelf'},
    },
    {
        piece: CostInformationPieceTypes.Trade,
        cost: [CardEnum.Cloth],
        title: {key: 'strings:game.cards.progress.title.Trade'},
    },
    {
        piece: CostInformationPieceTypes.Politics,
        cost: [CardEnum.Coin],
        title: {key: 'strings:game.cards.progress.title.Politics'},
    },
    {
        piece: CostInformationPieceTypes.Science,
        cost: [CardEnum.Paper],
        title: {key: 'strings:game.cards.progress.title.Science'},
    },
]

export function getCostInformation(gameMode: ModeSettingEnum): CostInformation[] {
    switch(gameMode) {
        case ModeSettingEnum.Seafarers4P:
        case ModeSettingEnum.Seafarers56P:
            return [...baseGameCostsInformation, ...developmentCostInformation, ...seafarersCosts]
        case ModeSettingEnum.CitiesAndKnights4P:
        case ModeSettingEnum.CitiesAndKnights56P:
            return [...baseGameCostsInformation, ...citiesAndKnightsCosts]
        case ModeSettingEnum.CitiesAndKnightsSeafarers4P:
        case ModeSettingEnum.CitiesAndKnightsSeafarers56P:
            return [...baseGameCostsInformation, ...seafarersCosts, ...citiesAndKnightsCosts]
        default:
            return [...baseGameCostsInformation, ...developmentCostInformation]
    }
}

export function getPieceIconPath(piece: CostInformationPieceTypes, color: PlayerColor): string {
    return getImagePath(getPieceIcon(piece, color))
}

function getPieceIcon(piece: CostInformationPieceTypes, colorEnum: PlayerColor): string {
    const isPlayerSpectator = colorEnum === 0
    const color = PlayerColor[isPlayerSpectator ? PlayerColor.Blue : colorEnum].toLowerCase()
    switch(piece) {
        case CostInformationPieceTypes.Road:
            return `road_${color}.svg`
        case CostInformationPieceTypes.Settlement:
            return `settlement_${color}.svg`
        case CostInformationPieceTypes.City:
            return `city_${color}.svg`
        case CostInformationPieceTypes.DevelopmentCard:
            return 'card_devcardback.svg'
        case CostInformationPieceTypes.Ship:
            return `ship_${color}_north_west.svg`
        case CostInformationPieceTypes.CityWall:
            return `city_wall_${color}.svg`
        case CostInformationPieceTypes.PurchaseKnight:
            return `knight_level1_inactive_${color}.svg`
        case CostInformationPieceTypes.ActivateKnight:
            return `knight_level1_active_${color}.svg`
        case CostInformationPieceTypes.UpgradeKnight:
            return `icon_knight_upgrade.svg`
        case CostInformationPieceTypes.Trade:
            return `icon_square_active_trade.svg`
        case CostInformationPieceTypes.Politics:
            return `icon_square_active_politics.svg`
        case CostInformationPieceTypes.Science:
            return 'icon_square_active_science.svg'
    }
}
